module.exports = __webpack_public_path__ + "img/cucumberslaw.3dfe0db4.jpg";